<header class="navbar-left">
    <div class="logo">
        <a class="logo-link"> <svg xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="logo" x="0px" y="0px"
                viewBox="0 0 283.4 113.8" enable-background="new 0 0 283.4 113.8" xml:space="preserve">
                <path id="kpmg-logo" fill="#ffffff"
                    d="M281.2,86.7h-14.7l2.4-9.7h-29.5l-2.4,9.7h-14.3v-2c0.2-1.1,0.4-2.2,0.7-3.5  c2.6-10.5,9.5-20.9,21.4-20.9c4.7,0,9.4,1.8,8.8,8.3h17.6c0.7-3,1.9-8.2-1.5-13c-3.7-5.2-11.3-7.3-21.1-7.3c-7,0-17.1,1.1-25.9,6.8  v-53h58.5V86.7z M246.7,100.9c-3.3,0.6-6.7,1-9.8,1c-8.4,0-14.3-3.9-14.4-13.1h27.2L246.7,100.9z M213,52.7l0,12.1  c-4.1,5.6-6.6,11.8-7.8,16.7c-0.4,1.7-0.8,3.4-0.9,5.1h-8.6l7.3-34.9l-24.7,0l-22.1,34.9h-1.6V2.2H213V52.7z M180.4,86.7h-8.8  l13.3-20.9L180.4,86.7z M144.9,51.7h-14.6l-10,34.9h-15.5c7.9-2.9,12.7-8.5,14.2-16.8c1.2-6.4,0.6-10.7-2-13.8  c-3.9-4.7-11.8-4.3-18.8-4.3c-1.2,0-11.6,0-11.6,0V2.2h58.4V51.7z M135.5,86.7l6.2-21.9l0.2,21.9H135.5z M93,78.4L93,78.4  c-0.6,0-1.2,0.1-1.8,0.1c-0.9,0-1.5,0-2.1,0l-3.7,0L87,72l0.8-3.2l2-7.4c0.9,0,1.7,0,2.5,0c1,0,2,0,2.9,0c4.9,0,8.1,0.3,9.2,1.9  c0.9,1.2,0.8,3.3-0.3,6.4C102.4,75.1,100.2,77.8,93,78.4 M76.7,54.8l-0.9,3l-8.4,27.8l-0.3,1H39.6l-2.1-4.5l29.7-30.3H48.1l-23.2,25  l7.5-25H18.3V2.2h58.4V54.8z M220.5,0v56.8c-2,1.6-3.7,3.2-5.2,5.1V0h-62.9v51.7h-5.2V0H84.2v51.8H79V0H16.1v59L0,112.6h14.1  l7.1-23.7h2L35,112.6H52L40.7,88.9h25.8l-7.2,23.7h15.4l7.1-23.6h3.4v-0.1H90h0.4h29.1l-6.8,23.6h15.6l6.6-23.6h7l0.2,23.6h13.1  l15-23.6h9.8l-5.1,23.6h15.3l5-23.6h8.9c-0.4,7.3,1.5,14,6.4,18.5c5.9,5.5,15.1,6.5,21.8,6.5c9.2,0,18.8-1.3,28.5-3.5l5.3-21.5h17.5  V0H220.5z">
                </path>
                <rect x="-46.9" y="-88.9" display="none" fill="none" width="393.2" height="290.3"></rect>
            </svg></a>
    </div>
    <a>
        <div class="app-title"> Research Credit Navigator</div>
    </a>
</header>
<div class="welcome-screen">
    <div class="welcome-content">
        <div class="welcome-text">Have you set up Multi-factor Authentication (MFA) with KPMG before?</div>
        <div class="welcome-image-container">
            <div class="welcome-image-1">
                <img class="mfa-setup" src="../../../assets/MFA-Setup_Image01.svg">
            </div>
            <div class="welcome-image-2">
                <div class="welcome-anim-left">
                    <img class="mfa-setup" src="../../../assets/MFA-Setup_Image02.svg">
                    <div>
                    <button type="button" class="btn btn-primary pad-adjust" (click)="login()">Access
                        Survey</button>
                    </div>
                </div>
                <div><img class="welcome-image-flow" src="../../../assets/MFA-Setup_Path01.svg"></div>
                <div><img class="welcome-image-flow" src="../../../assets/MFA-Setup_Path02.svg"></div>
                <div class="welcome-anim-right"><img class="welcome-image-first" src="../../../assets/MFA-Setup_Image03.svg">
                 <div>   <button type="button" class="btn btn-primary pad-adjust" (click)="scrollToMfaSetup()">Set
                        Up
                        MFA</button>
                    </div>
                </div>
            </div>
            <div>


            </div>
        </div>
        <div class="support-mail">
            <a [href]="emailstrings" tabindex="0" (click)="helpEmail()" title="Contact Support Team">
                <i class="mfa-setup-img">
                    <svg width="24px" height="22px" viewBox="0 0 24 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>Icon</title>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Process-Diagram-4.4" transform="translate(-708.000000, -602.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                <g id="Chart" transform="translate(261.000000, 135.000000)">
                                    <g id="Contact-us" transform="translate(344.000000, 446.000000)">
                                        <g id="Primary-Button-Copy-2" transform="translate(84.000000, 0.000000)">
                                            <g id="Group" transform="translate(19.190476, 19.190476)">
                                                <g id="Shape" transform="translate(0.000000, 2.361905)">
                                                    <path d="M21.2571429,4.78285714 L11.8095238,10.7614286 L2.36190476,4.78285714 L2.36190476,2.39142857 L11.8095238,8.37 L21.2571429,2.39142857 M21.2571429,0 L2.36190476,0 C1.05104762,0 0,1.06418571 0,2.39142857 L0,16.74 C0,18.0607495 1.05746078,19.1314286 2.36190476,19.1314286 L21.2571429,19.1314286 C22.5615868,19.1314286 23.6190476,18.0607495 23.6190476,16.74 L23.6190476,2.39142857 C23.6190476,1.06418571 22.5561905,0 21.2571429,0 Z"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </i>
            </a>
            <h4 style="padding:15px;">Having issues? Ask for help!</h4>
        </div>
    </div>
</div>
<div class="welcome-page-2">
    <div id="mfa" class="mfa-setup-header">
        <div> Steps to set Up Multi-factor Authentication (MFA) using Microsoft Authenticator</div>
    </div>
    <section class="mfa-setup-detail">
        <nav>
            <ul>
                <li><a href="javascript:void(0)" (click)="scrollToMfaSetup()">STEP 1 <br> Set up using Phone method</a>
                </li>
                <li><a href="javascript:void(0)" (click)="scrollToSteps(2)">STEP 2 <br> Add your mobile number</a></li>
                <li><a href="javascript:void(0)" (click)="scrollToSteps(3)">STEP 3 <br> Text Me option</a></li>
                <li><a href="javascript:void(0)" (click)="scrollToSteps(4)">STEP 4 <br> Call Me option</a></li>
                <li><a href="javascript:void(0)" (click)="scrollToSteps(5)">STEP 5 <br> Verification code sent to your
                        work email</a></li>
            </ul>
            <div> <button type="button" class="btn btn-primary" (click)="login()">Start setting up MFA</button></div>
        </nav>
        <article>
            <div id="step1" class="step">
                <div class="mfa-step-text">
                    <div class="num">1</div>
                    <p>Set Up Using Phone Method</p>
                    <div class="mfa-step-desc"> Select to set up using ‘Phone’. Click <u><b>I want to setup a different</b></u> method
                        and select <b>Phone</b> from
                        the
                        drop-down list and then select <b>Confirm</b>.</div>
                </div>
                <img src="../../../assets/Step1.1.png" alt="">
                <img src="../../../assets/Step1.2.png" alt="">
            </div>
            <div id="step2" class="step">
                <div class="mfa-step-text">
                    <div class="num">2</div>
                    <p>Add Your Mobile Number</p>
                    <div class="mfa-step-desc">On the Phone page, type the phone number for your mobile device, choose
                        <b>Text me</b> or <b>Call me</b> and
                        then
                        select Next.</div>
                </div>
                <img src="../../../assets/Step2.png" alt="">
            </div>
            <div id="step3" class="step">
                <div class="mfa-step-text">
                    <div class="num">3</div>
                    <p>Text Me Option: Enter verification code</p>
                    <div class="mfa-step-desc">Type the verification code from the text message sent to your phone from
                        Microsoft and then
                        select
                    <b>Next</b>.</div>
                </div>
                <img src="../../../assets/Step3.1.png" alt="">
                <img src="../../../assets/Step3.2.png" alt="">
            </div>
            <div id="step4" class="step">
                <div class="mfa-step-text">
                    <div class="num">4</div>
                    <p>Call Me Option: Answer the verification phone call</p>
                    <div class="mfa-step-desc"> Answer the verification phone call, sent to the phone number you
                        entered, and follow the
                        instructions.</div>
                </div>
                <img src="../../../assets/Step4.2.png" alt="">
                <img src="../../../assets/Step4.2.png" alt="">
                <div class="mfa-step-desc">
                    Select <b>Yes</b> to stay signed in.
                </div>
                <img src="../../../assets/Step4.3.png" alt="">
            </div>
            <div id="step5" class="step">
                <div class="mfa-step-text">
                    <div class="num">5</div>
                    <p>Optional: Enter verification code sent to your work email</p>
                    <div class="mfa-step-desc">
                        Some organizations require you to enter a code sent to your work email address. Enter the code
                        and
                        then click <b>Sign in</b>.</div>

                </div>
                <img src="../../../assets/Step5.1.png" alt="">
                <img src="../../../assets/Step5.2.png" alt="">
            </div>
            <div id="step6" class="step">
                <div class="mfa-step-text">
                    <div class="mfa-step-desc"><b>Success!</b> You will now see the Navigator and surveys assigned to you.
                    </div>
                    <img src="../../../assets/Step6.png" alt="">
                </div>
            </div>
            <div class="footer">
                <button type="button" style="float:left;" class="btn btn-primary" (click)="login()">Start setting up MFA</button>
                <div class="back-to-top">
                <a href="javascript:void(0)" (click)="scrollToMfaSetup()" >
                   <span>Back to top</span>
                    <i>
                        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>Icon</title>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Process-Diagram-4.4" transform="translate(-1360.000000, -5246.000000)" fill="#66B4FF" fill-rule="nonzero">
                                <g id="Back-to-top" transform="translate(1253.000000, 5233.000000)">
                                    <g id="Ghost-Button-(Dark-Mode)-/-Icon-Circle" transform="translate(94.000000, 0.000000)">
                                        <g id="Path" transform="translate(13.000000, 13.000000)">
                                            <polygon points="9.01010101 16 6.98989899 16 6.98989899 3.87878788 1.43434343 9.43434343 0 8 8 0 16 8 14.5656566 9.43434343 9.01010101 3.87878788"></polygon>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </i>
                </a>
            </div>
            </div>
        </article>

    </section>
</div>